export function getRequestErrorMessage(request, fallback) {
    const response = request?.responseText || request?.response;
    if (response) {
        try {
            const parsed = JSON.parse(response);
            const message = parsed?.error ?? parsed?.message;
            if (typeof message === "string" && message.trim()) {
                return message.trim();
            }
        }
        catch {
            // The response is not JSON; use the stable user-facing fallback.
        }
    }
    const status = request?.status;
    const statusText = request?.statusText?.trim();
    return status && statusText ? `${fallback} (${status} ${statusText})` : fallback;
}
